import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';

import { InjectedAppScrollerProps, withAppScroller } from 'src/_context/AppScroller';
import responsive from 'src/constants/responsive';
import stylesheet, { directions } from 'src/constants/stylesheet';
import FadeInUp from 'src/utils/FadeInUp';

export type SectionProps =
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> &
    {
        dto: PanelTextQuoteDto,
        title?: string;
        text?: React.ReactNode;
        quote?: React.ReactNode;
        autor?: string;
        reverse?: boolean;
    };

const styles = {
    container: {
        ...stylesheet.PaddingGutter(1, directions.top),
        '&:last-of-type $columnMobileLines:last-child:after': {
            [responsive.Mobile]: {
                height: 0
            }
        }
    },
    title: {
        textAlign: 'center',
        ...stylesheet.PaddingGutter(.15, directions.bottom)
    },
    Subtitle_2: {
        ...stylesheet.Subtitle_2,
    },
    main: {
        position: 'relative',
        display: 'flex',
        height: '100%',
        alignItems: 'center',

        [responsive.Mobile]: {
            flexDirection: 'column'
        },
        [responsive.AfterMobile]: {
            '&:before': {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: '50%',
                width: 1,
                background: 'black'
            },
        }
    },
    mainReverse: {
        [responsive.Mobile]: {
            flexDirection: 'column'
        },
        [responsive.AfterMobile]: {
            flexDirection: 'row-reverse'
        }
    },
    column: {
        position: 'relative',
        height: '100%',
        display: 'flex',
        flex: '1 0 50%',
        alignItems: 'center',
        boxSizing: 'border-box',
        justifyContent: 'center',
        [responsive.Mobile]: {
            '&:after': {
                content: '"',
                position: 'absolute',
                bottom: 0,
                ...stylesheet.PostionGutter(1, directions.sides),
                height: 1,
                background: 'black'
            }
        },
        [responsive.AfterMobile]: {
            width: '50%'
        },
        ...stylesheet.PaddingGutter(1, directions.all)
    },
    columnMobileLines: {
        position: 'relative',

        [responsive.Mobile]: {
            '&:after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                ...stylesheet.PostionGutter(1, directions.sides),
                height: '1px',
                background: 'black',
            },
            '$container:last-of-type &:after': {
                height: 0
            }
        }
    },
    columnSpan: {
        ...stylesheet.TextBlocks,
        [responsive.AfterMobile]:
        {
            ...stylesheet.PaddingGutter(.5, directions.sides)
        },
        '& a': {
            display: 'inline-block',
            position: 'relative',
            borderBottom: '1px solid black',

            '&:hover': {
                borderColor: 'transparent'
            },

            ...stylesheet.Link(false, 'center'),
        }
    },
    quote: {
        ...stylesheet.Quote,
        ...stylesheet.PaddingGutter(.5, directions.sides)
    },
    autor: {
        ...stylesheet.Caption,
        ...stylesheet.PaddingGutter(.2, directions.top)
    }
};

type Props =
    SectionProps &
    StyledComponentProps<keyof typeof styles> &
    InjectedAppScrollerProps;

type State = {
};
class Section extends React.Component<Props, State> {
    private container: React.RefObject<HTMLElement> = React.createRef<HTMLElement>();
    constructor(props: Props) {
        super(props);

        this.state = {
        };
    }

    render() {
        const {
            children,
            classes,
            dto: { Text, Title, Quote, Source, showTitle },
            reverse,
            appScrollerCtx,
            ...rest
        } = this.props;

        return (
            <section ref={this.container} {...rest} className={classNames(rest.className, classes!.container)}>
                {showTitle && <FadeInUp>
                    {Title && <h2 className={classNames(classes!.title, classes!.Subtitle_2)}>{Title}</h2>}
                </FadeInUp>}
                <div className={classNames(classes!.main, reverse && classes!.mainReverse)}>
                    <div className={classNames(classes!.column, classes!.columnMobileLines)}>
                        <FadeInUp>
                            <div className={classes!.columnSpan} dangerouslySetInnerHTML={{ __html: Text }} />
                        </FadeInUp>
                    </div>
                    <div className={
                        classNames(
                            classes!.column,
                            classes!.columnMobileLines)}
                    >
                        {Quote && <div className={classes!.quote}>
                            <FadeInUp>
                                <div dangerouslySetInnerHTML={{ __html: Quote }} />
                                {Source &&
                                    <div className={classes!.autor}>
                                        {Source}
                                    </div>}
                            </FadeInUp>
                        </div>}
                    </div>
                </div>
                {children}
            </section>);
    }
}

export default withStyles(styles)(withAppScroller(Section));


// WEBPACK FOOTER //
// ./src/components/Panels/PanelTextQuote.tsx